import { api } from "@/lib/api";
import { toast } from "sonner";

const STAGE_OPTIONS = [
    { key: "group", label: "Group" },
    { key: "r32", label: "R32" },
    { key: "r16", label: "R16" },
    { key: "qf", label: "QF" },
    { key: "sf", label: "SF" },
    { key: "final", label: "Final" },
    { key: "champion", label: "Champion" },
];

export default function AdvanceTeamsTab({ tournament, onChanged }) {
    const handleAdvance = async (teamId, newStage) => {
        await api.advanceTeams(tournament.id, { team_ids: [teamId], new_stage: newStage });
        toast.success(`Moved to ${newStage}`);
        onChanged?.();
    };

    const handleToggleEliminated = async (teamId, nextValue) => {
        try {
            await api.advanceTeams(tournament.id, { team_ids: [teamId], eliminated: nextValue });
            toast.success(nextValue ? "Marked eliminated" : "Marked still alive");
            onChanged?.();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Failed to update");
        }
    };

    return (
        <div className="space-y-4 min-w-0">
            <h2 className="font-display font-extrabold text-xl uppercase break-words">Advance Teams</h2>
            <p className="text-xs text-zinc-500">Move teams up OR down the bracket. Use the <span className="text-blaze font-bold">Eliminated</span> checkbox to explicitly mark a team out (e.g. group-stage teams that didn't qualify). Knockout matches auto-set eliminated when submitted.</p>
            <div className="space-y-2">
                {tournament.teams.map(t => (
                    <div key={t.id} data-testid={`advance-row-${t.id}`} className={`flex flex-wrap items-center justify-between gap-2 p-3 border-2 rounded-md bg-ink ${t.eliminated ? "border-blaze/40 opacity-70" : "border-[#333]"}`}>
                        <div className="flex items-center gap-2 min-w-[180px]">
                            <span className="text-lg">{t.flag || "🏳️"}</span>
                            <span className="font-semibold">{t.name}</span>
                            <span className="text-xs text-zinc-500">at {t.stage_reached}</span>
                            {t.eliminated && <span className="pill bg-blaze/10 border-blaze text-blaze text-[9px]">OUT</span>}
                        </div>
                        <div className="flex flex-wrap items-center gap-2">
                            <div className="flex flex-wrap gap-1">
                                {STAGE_OPTIONS.map(s => (
                                    <button key={s.key}
                                        data-testid={`advance-${t.id}-to-${s.key}-btn`}
                                        onClick={() => handleAdvance(t.id, s.key)}
                                        className={`text-[10px] uppercase font-bold px-2 py-1 border-2 rounded-md ${t.stage_reached === s.key ? "border-cyber bg-cyber text-black" : "border-[#333] text-zinc-400 hover:border-cyber"}`}>
                                        {s.label}
                                    </button>
                                ))}
                            </div>
                            <label
                                data-testid={`advance-${t.id}-eliminated-label`}
                                className="flex items-center gap-1.5 cursor-pointer px-2 py-1 border-2 border-[#333] rounded-md hover:border-blaze"
                            >
                                <input
                                    type="checkbox"
                                    data-testid={`advance-${t.id}-eliminated-checkbox`}
                                    checked={!!t.eliminated}
                                    onChange={(e) => handleToggleEliminated(t.id, e.target.checked)}
                                    className="accent-blaze"
                                />
                                <span className="text-[10px] uppercase font-bold text-zinc-300">Eliminated</span>
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
